module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "ca-team-reports-upsell-illustration-2x.617109b5.png" + "?" + Date.now();